var map = {
	"./en/index.js": [
		"20d1",
		"chunk-65412154"
	],
	"./zh-CN/index.js": [
		"9048",
		"chunk-458a03c3"
	],
	"./zh-TW/index.js": [
		"1f96",
		"chunk-5d007ab1"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5641";
module.exports = webpackAsyncContext;